import { Coordinate, Coordinates } from '@bpd-library/types';

import {
    AreaProjectModel,
    ConstructionNumberModel,
    DistrictModel,
    ProjectPhaseModel,
    PropertyTypeModel,
} from '../../generated';
import { calculateCenter } from '../../geometry';

const validateCoordinates = (coordinates: Coordinates) => {
    const validates = coordinates.every((coordinate) =>
        coordinate.every(([longitude, latitude]) => {
            return longitude < 180 && longitude > -180 && latitude > -90 && latitude < 90;
        }),
    );

    return validates;
};

function getApiObjectCenter(
    apiObject: AreaProjectModel | ProjectPhaseModel | DistrictModel,
): Coordinates | false;
function getApiObjectCenter(
    apiObject: AreaProjectModel | ProjectPhaseModel | DistrictModel,
    options?: { as?: 'coordinates' },
): Coordinates | false;
function getApiObjectCenter(
    apiObject: AreaProjectModel | ProjectPhaseModel | DistrictModel,
    options?: { as?: 'coordinate' },
): Coordinate | false;

function getApiObjectCenter(
    apiObject: AreaProjectModel | ProjectPhaseModel | DistrictModel,
    options?: { as?: 'coordinates' | 'coordinate' },
) {
    const { location } = apiObject;

    let coordinates: Coordinates | undefined;

    if (location) {
        coordinates = [[location as Coordinate]];
    } else if (getApiObjectCoordinates(apiObject)) {
        coordinates = getApiObjectCoordinates(apiObject);
        coordinates = coordinates ? [[calculateCenter(coordinates)]] : undefined;
    }

    if (!coordinates || !validateCoordinates(coordinates)) return false;

    if (options?.as === 'coordinate') return coordinates[0][0];

    return coordinates;
}

const getApiObjectCoordinates = ({
    geometry,
}: DistrictModel | ProjectPhaseModel | PropertyTypeModel | ConstructionNumberModel):
    | Coordinates
    | undefined => {
    if (!geometry?.length) return;

    const coordinates = geometry
        .filter(({ coordinates }) => !!coordinates)
        .map(({ coordinates }) => coordinates as Coordinate[]);

    return coordinates?.length ? coordinates : undefined;
};

export { validateCoordinates, getApiObjectCenter, getApiObjectCoordinates };
